export class HashSetString {
    constructor(init) {
        if (typeof init === "undefined")
            return;
        init.forEach(i => {
            this[i] = true;
        });
    }
    isEmpty() {
        for (const key in this) {
            return false;
        }
        return true;
    }
    remove(value) {
        this[value] = undefined;
    }
    set(value) {
        this[value] = true;
    }
    contains(key) {
        if (typeof this[key] === "undefined") {
            return false;
        }
        return true;
    }
    forEach(func) {
        for (const key in this) {
            func(key);
        }
    }
    entries() {
        const keys = [];
        for (const key in this) {
            keys.push(key);
        }
        return keys;
    }
    clear() {
        const keys = this.entries();
        keys.forEach(k => delete this[k]);
    }
}
